/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of batch job to execute
 * @export
 */
export const WebApiModelsEnumerationTypesJobType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;
export type WebApiModelsEnumerationTypesJobType = typeof WebApiModelsEnumerationTypesJobType[keyof typeof WebApiModelsEnumerationTypesJobType];


export function WebApiModelsEnumerationTypesJobTypeFromJSON(json: any): WebApiModelsEnumerationTypesJobType {
    return WebApiModelsEnumerationTypesJobTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesJobTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesJobType {
    return json as WebApiModelsEnumerationTypesJobType;
}

export function WebApiModelsEnumerationTypesJobTypeToJSON(value?: WebApiModelsEnumerationTypesJobType | null): any {
    return value as any;
}

